import { PaymentWerouteProps, AdaptedPaymentWerouteProps } from './PaymentWeroute.types';

/**
 * PaymentWeroute 컴포넌트 속성 변환 함수
 * 에디터에서 전달된 props를 컴포넌트에서 사용할 수 있는 형태로 변환
 */
export function adaptPaymentWerouteProps(props: PaymentWerouteProps | any): AdaptedPaymentWerouteProps {
  const { id, style = {}, className, ...rest } = props;
  
  // 기본 구조 생성
  const adaptedProps: AdaptedPaymentWerouteProps = {
    id,
    style,
    className,
    data: {}
  };
  
  // componentProps를 data 객체로 변환
  const componentProps = rest.componentProps || rest;
  
  // 필요한 속성 추출 및 변환
  adaptedProps.data = {
    title: componentProps.title || '결제',
    description: componentProps.description || '결제를 진행해주세요.',
    checkoutId: componentProps.checkoutId,
    userId: componentProps.userId,
    companyId: componentProps.companyId,
    skinId: componentProps.skinId,
    pgcode: componentProps.pgcode || 'mobile',
    returnUrl: componentProps.returnUrl || window.location.origin + '/payment/weroute/success',
    callbackUrl: componentProps.callbackUrl || window.location.origin + '/api/payment/weroute/callback',
    cancelUrl: componentProps.cancelUrl || window.location.origin + '/payment/weroute/fail',
    buttonText: componentProps.buttonText || '결제하기',
    buttonStyle: componentProps.buttonStyle || {},
    showDescription: componentProps.showDescription !== false,
    // device 객체가 있으면 그대로 사용
    device: componentProps.device
  };
  
  return adaptedProps;
}